import axios from "axios";
import { useContext } from "react";
import queryString from "query-string";

import {
  TwitchContextContext,
  TwitchAuthContext,
  TwitchBroadcastContext,
  TwitchBitsContext,
} from "../contexts";

const queryParams = queryString.parse(window.location.search);
const isHostedOnTwitch = Boolean(queryParams.state);

export default function useTwitch() {
  const twitch = window.Twitch.ext;

  const auth = useContext(TwitchAuthContext);
  const context = useContext(TwitchContextContext);
  const bits = useContext(TwitchBitsContext);
  const { addPubSubEventListener, removePubSubEventListener } = useContext(
    TwitchBroadcastContext
  );

  const useBitsPromisified = (sku) => {
    if (!isHostedOnTwitch) {
      twitch.bits.setUseLoopback(true);
    }

    return new Promise((resolve, reject) => {
      twitch.bits.onTransactionComplete(resolve);
      twitch.bits.onTransactionCancelled(reject);
      twitch.bits.useBits(sku);
    });
  };

  const getBroadcasterType = async () => {
    try {
      const response = await axios.get(
        `https://api.twitch.tv/helix/users?id=${auth.channelId}`,
        {
          headers: {
            "Client-ID": process.env.TWITCH_EXTENSION_CLIENT_ID,
            Authorization: `Extension ${auth.helixToken}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data.data[0].broadcaster_type;
      }

      return null;
    } catch (err) {
      return null;
    }

    return null;
  };

  return {
    auth,
    context,
    channelId: auth.channelId,
    actions: twitch.actions,
    bits: {
      ...twitch.bits,
      products: bits.products,
      useBitsPromisified,
    },
    features: twitch.features,
    viewer: twitch.viewer,
    role: twitch.viewer.role,
    isLinked: twitch.viewer.isLinked,
    addPubSubEventListener,
    removePubSubEventListener,
    getBroadcasterType,
  };
}
